import { render, staticRenderFns } from "./my_slide_page.vue?vue&type=template&id=8b8f6432&scoped=true&"
import script from "./my_slide_page.vue?vue&type=script&lang=js&"
export * from "./my_slide_page.vue?vue&type=script&lang=js&"
import style0 from "./my_slide_page.vue?vue&type=style&index=0&id=8b8f6432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8f6432",
  null
  
)

export default component.exports